(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar__container', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      prevEl: '.announcement-bar .swiper-button-prev',
      nextEl: '.announcement-bar .swiper-button-next'
    },
    speed: 600
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-product-slider"]) return;
  try {
    
  const testimonialSlider = new Swiper('.product-slider__container', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    navigation: {
      prevEl: '.product-slider .swiper-button-prev',
      nextEl: '.product-slider .swiper-button-next'
    },
    scrollbar: {
      el: '.product-slider .swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
        loop: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
    let customerLinks = document.querySelectorAll(".customer__alt-link")
    let formMessages = document.querySelectorAll(".form__message")
    let formErrors = document.querySelectorAll("form .errors")
    customerLinks.forEach( (link) => {
        link.addEventListener( "click", () => {
            if (formMessages) {
                formMessages.forEach( (message) => {
                    message.remove()
                })
            }
            if (formErrors) {
                formErrors.forEach( (error) => {
                    error.remove()
                })
            }
        })
    })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-the-exhibits"] && !Shopify.designMode) return;
  try {
    
  const exploreSlider = new Swiper('.explore-exhibits__container', {
    slidesPerView: 1.45,
    spaceBetween: 20,
    loop: false,
    allowTouchMove: true,
    scrollbar: {
      el: '.explore-exhibits__scrollbar',
      draggable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-articles"] && !Shopify.designMode) return;
  try {
    
  const featuredArticlesSlider = new Swiper('.featured-articles__wrapper', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    allowTouchMove: true,
    navigation: {
      prevEl: '.featured-articles-prev',
      nextEl: '.featured-articles-next'
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            allowTouchMove: false
        }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Mobile dropdowns
  const headerItems = document.querySelectorAll('.footer__heading-mobile');

  headerItems.forEach(header => {
    header.addEventListener('click', event => {
      const parent = header.parentElement;
      const content = header.nextElementSibling;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });

  // Credits
  const creditsButtons = document.querySelectorAll('a[href="#credits"]');
  const creditsCloseButtons = document.querySelectorAll('.site-credits__close');
  const credits = document.querySelector('.site-credits');

  creditsButtons.forEach(creditsButton => {
    creditsButton.addEventListener('click', event => {
      event.preventDefault();
      credits.classList.add('is-visible');

      document.addEventListener('keydown', function(event){
        if (event.key === "Escape") {
          credits.classList.remove('is-visible');
        }
      });
    });
  });

  creditsCloseButtons.forEach(creditsCloseButton => {
    creditsCloseButton.addEventListener('click', event => {
      credits.classList.remove('is-visible');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Megamenu Overlay
  const menuItems = document.querySelectorAll('.header__mega-menu-wrapper');
  const pageOverlay = document.querySelector('.page-overlay-under-menu');
  menuItems.forEach(menuItem => {
    menuItem.addEventListener('mouseenter', event => {
      pageOverlay.classList.add('is-visible');
    });

    menuItem.addEventListener('mouseleave', event => {
      pageOverlay.classList.remove('is-visible');
    });
  });

  // Search
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  openSearch.addEventListener('click', () => {
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
    } else {
      search.classList.add('is-visible');
    }
  });

  closeSearch.addEventListener('click', () => {
    search.classList.remove('is-visible');
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  // Product mobile slider
  const instagramSlider = document.querySelector('.instagram__images');
  let instagramSliderInstance = {};
  const settingsSlider = {
    loop: true,
    spaceBetween: 20
  }

  window.addEventListener('load', instagramSliderOnLoadOrResize);
  window.addEventListener('resize', instagramSliderOnLoadOrResize);

  function instagramSliderOnLoadOrResize() {
    if (window.innerWidth > 768) {
      if (instagramSlider.classList.contains('swiper-initialized')) {
        instagramSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!instagramSlider.classList.contains('swiper-initialized')) {
        instagramSliderInstance = new Swiper('.instagram__images', settingsSlider);
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupCloseButtons = document.querySelectorAll('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupCloseButtons.forEach(legalPopupClose => {
    legalPopupClose.addEventListener('click', event => {
      const day = legalPopup.dataset.day;
  
      legalPopup.classList.remove('is-visible');
      setCookie('legalCookie', true, day);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  const shareNetworkBtns = document.querySelectorAll('[data-share-network]')

  const shareNetwork = (network, shareLink = window.location.href) => {
    switch (network) {
      case 'facebook':
        window.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(shareLink)+"&title="+document.title, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=550,width=800')
        break
      case 'twitter':
        window.open("https://twitter.com/share?url="+ encodeURIComponent(shareLink)+"&text="+document.title, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=550,width=800')
        break
      case 'email':
        window.location.href = `mailto:?subject=I'd like to share a link with you&body=${shareLink}`
        break
    }
  }

  shareNetworkBtns.forEach(el => {
    el.addEventListener('click', (event) => {
      event.preventDefault()
      const network = el.getAttribute('data-share-network')
      shareNetwork(network)
    })
  })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const testimonialSlider = new Swiper('.Product_Upsell_Slider', {
    slidesPerView: 1,
    loop: false,
    navigation: {
      prevEl: '.Product_Upsell_Slider .swiper-button-prev',
      nextEl: '.Product_Upsell_Slider .swiper-button-next'
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  const newsletterPopup = document.querySelector('.newsletter-popup-wrapper');
  const newsletterPopupClose = document.querySelector('.newsletter-popup__close');
  const newsletterPopupOpen = document.querySelectorAll('[href="#open-newsletter"]');
  const pageOverlayElement = document.querySelector('.page-overlay');

  if (getCookie('newsletterCookie')) {
    newsletterPopup.classList.remove('is-visible');
  } else {
    const delay = (Number(newsletterPopup.dataset.delay) * 1000) || 5000;

    setTimeout(function() {
      newsletterPopup.classList.add('is-visible');
      pageOverlayElement.classList.add('is-visible');
    }, delay);
  }

  newsletterPopupClose.addEventListener('click', event => {
    const day = 1;

    newsletterPopup.classList.remove('is-visible');
    pageOverlayElement.classList.remove('is-visible');
    setCookie('newsletterCookie', true, day);
  });

  newsletterPopupOpen.forEach(btn => {
    btn.addEventListener('click', event => {
      newsletterPopup.classList.add('is-visible');
      pageOverlayElement.classList.add('is-visible');
    });

    pageOverlayElement.addEventListener('click', event => {
      newsletterPopup.classList.add('is-visible');
      pageOverlayElement.classList.add('is-visible');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !Shopify.designMode) return;
  try {
    
  // Show bar after scroll
  const productSectionHeight = document.querySelector('.product').offsetHeight - 200;
  const headroom = new Headroom(document.querySelector('.product-bar'), { offset: productSectionHeight });
  headroom.init();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  const size = Number(document.querySelector('.product-related__container').dataset.size);
  const relatedSlider = new Swiper('.product-related__container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    allowTouchMove: true,
    scrollbar: {
      el: '.product-related__scrollbar',
      draggable: true
    },
    breakpoints: {
      768: {
        slidesPerView: size,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  const testimonialSlider = new Swiper('.product-slider__container', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    navigation: {
      prevEl: '.product-slider .swiper-button-prev',
      nextEl: '.product-slider .swiper-button-next'
    },
    scrollbar: {
      el: '.product-slider .swiper-scrollbar',
      draggable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  const testimonialSlider = new Swiper('.testimonial-slider__slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      prevEl: '.testimonial-slider .swiper-button-prev',
      nextEl: '.testimonial-slider .swiper-button-next'
    },
    speed: 900,
    autoplay: {
      delay: 3000,
    }
  });

  } catch(e) { console.error(e); }
})();
})();
